/* eslint-disable */
import {
  Autocomplete,
  Button,
  FormControl,
  Grid,
  InputLabel,
  MenuItem,
  Paper,
  Select,
  TextField,
  Tooltip,
  Typography,
} from "@mui/material";
import IconButton from "@mui/material/IconButton";
import EditOutlinedIcon from "@mui/icons-material/EditOutlined";
import AddCircleOutlineOutlinedIcon from '@mui/icons-material/AddCircleOutlineOutlined';
import SearchIcon from "@mui/icons-material/Search";
import RemoveCircleOutlineIcon from "@mui/icons-material/RemoveCircleOutline";
import CleaningServicesIcon from "@mui/icons-material/CleaningServices";
import { Box } from "@mui/system";
import { Add } from "@mui/icons-material";
import { DataGrid } from "@mui/x-data-grid";
import { useEffect, useState, useContext } from "react";
import { getBlockProductos, getBlockProducto } from "../../services/BlockProductoService";
import { getCacheData } from "../../services/CacheService";
import Message from "../../utils/Message";
import BlockProductoDialog from "./BlockProductoDialog";
import WaitingDialog from "../../utils/WaitingDialog";
import AuthContext from "../../contexts/AuthContext";

const initialSearchData = {
  descripcion: "",
  descripcionCorta: "",
  idBlCrTipo: null,
  idBlCrMaterial: null,
  idBlCrMarca: null,
  idBlCrDiametro: null,
  idBlCrColor: null,
  estado: "habilitado",
};

const estadoOptions = [
  {
    id: "todo",
    descripcion: "Todo",
  },
  {
    id: "habilitado",
    descripcion: "Habilitado",
  },
  {
    id: "deshabilitado",
    descripcion: "Deshabilitado",
  },
];

const nameItemsText = "Productos de Blocks";
//
// #############################################################################
//
const BlockProductoTable = () => {
  const [searchData, setSearchData] = useState(initialSearchData);
  const [itemsCrud, setItemsCrud] = useState([]);
  const [itemCrud, setItemCrud] = useState({});
  const [actionCrud, setActionCrud] = useState("");
  const [isDoingSomething, setIsDoingSomething] = useState(false);
  const [openDialog, setOpenDialog] = useState(false);
  const [totalRowsCount, setTotalRowsCount] = useState(0);
  const [currentPage, setCurrentPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [message, setMessage] = useState({});
  const [showMessage, setShowMessage] = useState(false);
  const [blCrTipos, setBlCrTipos] = useState([]);
  const [blCrMateriales, setBlCrMateriales] = useState([]);
  const [blCrMarcas, setBlCrMarcas] = useState([]);
  const [blCrColores, setBlCrColores] = useState([]);
  const [blCrDiametros, setBlCrDiametros] = useState([]);
  const [valueACBlCrMarca, setValueACBlCrMarca] = useState({
    id: "",
    descripcion: "",
  });
  const [inputValueACBlCrMarca, setInputValueACBlCrMarca] = useState("");
  const [valueACBlCrMaterial, setValueACBlCrMaterial] = useState({
    id: "",
    descripcion: "",
  });
  const [inputValueACBlCrMaterial, setInputValueACBlCrMaterial] = useState("");
  const [valueACBlCrTipo, setValueACBlCrTipo] = useState({
    id: "",
    descripcion: "",
  });
  const [inputValueACBlCrTipo, setInputValueACBlCrTipo] = useState("");
  const [valueACBlCrColor, setValueACBlCrColor] = useState({
    id: "",
    descripcion: "",
  });
  const [inputValueACBlCrColor, setInputValueACBlCrColor] = useState("");
  const [valueACBlCrDiametro, setValueACBlCrDiametro] = useState({
    id: "",
    descripcion: "",
  });
  const [inputValueACBlCrDiametro, setInputValueACBlCrDiametro] = useState("");

  const { hasPermission } = useContext(AuthContext);
  const _crearBlockProducto = hasPermission("block-producto-c");
  const _editarBlockProducto = hasPermission("block-producto-e");
  const _habilitarBlockProducto = hasPermission("block-producto-h");
  const _deshabilitarBlockProducto = hasPermission("block-producto-d");

  const tableColumns = [
    {
      field: "descripcion",
      headerName: "Descripción",
      headerAlign: "center",
      align: "left",
      flex: 3,
      sortable: false,
      renderCell: (params) => {
        let _val = params.row.descripcion;
        _val = _val ? _val.toUpperCase() : "";
        return _val;
      },
    },
    {
      field: "descripcion_corta",
      headerName: "Descripción Abreviada",
      headerAlign: "center",
      align: "left",
      flex: 1,
      sortable: false,
      renderCell: (params) => {
        let _val = params.row.descripcion_corta;
        _val = _val ? _val.toUpperCase() : "";
        return _val;
      },
    },
    {
      field: "descripcion_bl_cr_marca",
      headerName: "Marca",
      headerAlign: "center",
      align: "left",
      flex: 1,
      sortable: false,
      renderCell: (params) => {
        let _val = params.row.descripcion_bl_cr_marca;
        _val = _val ? _val.toUpperCase() : "";
        return _val;
      },
    },
    {
      field: "descripcion_bl_cr_material",
      headerName: "Material",
      headerAlign: "center",
      align: "left",
      flex: 1,
      sortable: false,
      renderCell: (params) => {
        let _val = params.row.descripcion_bl_cr_material;
        _val = _val ? _val.toUpperCase() : "";
        return _val;
      },
    },
    {
      field: "descripcion_bl_cr_tipo",
      headerName: "Tipo",
      headerAlign: "center",
      align: "left",
      flex: 1,
      sortable: false,
      renderCell: (params) => {
        let _val = params.row.descripcion_bl_cr_tipo;
        _val = _val ? _val.toUpperCase() : "";
        return _val;
      },
    },
    {
      field: "descripcion_bl_cr_color",
      headerName: "Color",
      headerAlign: "center",
      align: "left",
      flex: 1,
      sortable: false,
      renderCell: (params) => {
        let _val = params.row.descripcion_bl_cr_color;
        _val = _val ? _val.toUpperCase() : "";
        return _val;
      },
    },
    {
      field: "habilitado",
      headerName: "Habilitado",
      headerAlign: "center",
      align: "center",
      flex: 1,
      sortable: false,
      renderCell: (params) => {
        let _val = params.row.habilitado ? "SI" : "";
        _val = _val ? _val.toUpperCase() : "";
        return _val;
      },
    },
    {
      field: "actions",
      headerName: "Acciones",
      headerAlign: "center",
      align: "left",
      flex: 1,
      sortable: false,
      filterable: false,
      renderCell: (params) => (
        <>
          {params.row.habilitado && _editarBlockProducto && (
            <Tooltip title="editar">
              <IconButton
                size="small"
                aria-label="update"
                onClick={() =>
                  handleClickActionCrud(params.row, "update")
                }
              >
                <EditOutlinedIcon />
              </IconButton>
            </Tooltip>
          )}

          {params.row.habilitado && _deshabilitarBlockProducto && (
            <Tooltip title="deshabilitar">
              <IconButton
                size="small"
                aria-label="disable"
                onClick={() =>
                  handleClickActionCrud(params.row, "disable")
                }
              >
                <RemoveCircleOutlineIcon />
              </IconButton>
            </Tooltip>
          )}

          {!params.row.habilitado && _habilitarBlockProducto && (
            <Tooltip title="habilitar">
              <IconButton
                size="small"
                aria-label="enable"
                onClick={() =>
                  handleClickActionCrud(params.row, "enable")
                }
              >
                <AddCircleOutlineOutlinedIcon />
              </IconButton>
            </Tooltip>
          )}
        </>
      ),
    },
  ];

  const handlePaginationModelChange = (newModel) => {
    setCurrentPage(newModel.page);
    setRowsPerPage(newModel.pageSize);
  };

  const tableOptions = {
    rowHeight: 40,
    columnHeaderHeight: 45,
    paginationMode: "server",
    rowCount: totalRowsCount,
    paginationModel: {
      page: currentPage,
      pageSize: rowsPerPage,
    },
    onPaginationModelChange: handlePaginationModelChange,
    pageSizeOptions: [10, 20, 30],
    disableRowSelectionOnClick: true,
    disableColumnMenu: true,
    disableColumnFilter: true,
    disableColumnSelector: true,
    disableDensitySelector: true,
    getRowId: (row) => row.id,
    localeText: {
      noRowsLabel: "",
      noResultsOverlayLabel: "",
      MuiTablePagination: {
        labelRowsPerPage: "Filas:",
        labelDisplayedRows: ({ from, to, count }) =>
          `${from}-${to} de ${count !== -1 ? count : `más de ${to}`}`,
      },
    },
    sx: {
      '& .MuiDataGrid-cell': {
        fontSize: '0.9em',
      },
      '& .MuiDataGrid-columnHeaders': {
        backgroundColor: '#f5f5f5',
      },
    },
  };
  //
  // ################################################################################
  //
  useEffect(() => {
    loadBlCrTipos();
    loadBlCrMateriales();
    loadBlCrMarcas();
    loadBlCrColores();
    loadBlCrDiametros();
  }, []);
  //
  // ################################################################################
  //
  useEffect(() => {
    load();
  }, [currentPage, rowsPerPage]);
  //
  // ################################################################################
  //
  const handleChange = (e) => {
    setSearchData({
      ...searchData,
      [e.target.name]:
        e.target.type === "checkbox" ? e.target.checked : e.target.value,
    });
  };
  //
  // ################################################################################
  //
  const handleLimpiar = () => {
    setSearchData(initialSearchData);
    setValueACBlCrTipo({
      id: "",
      descripcion: "",
    });
    setValueACBlCrMaterial({
      id: "",
      descripcion: "",
    });
    setValueACBlCrMarca({
      id: "",
      descripcion: "",
    });
    setValueACBlCrColor({
      id: "",
      descripcion: "",
    });
    setValueACBlCrDiametro({
      id: "",
      descripcion: "",
    });

    setItemsCrud([]);
    setCurrentPage(0);
  };
  //
  // ################################################################################
  //
  const handleBuscar = () => {
    if (currentPage !== 0) {
      setCurrentPage(0);
    } else {
      load();
    }
  };
  //
  // ################################################################################
  //
  const load = async () => {
    let _params = {
      descripcion: searchData.descripcion,
      descripcionCorta: searchData.descripcionCorta,
      idBlCrTipo: searchData.idBlCrTipo,
      idBlCrMaterial: searchData.idBlCrMaterial,
      idBlCrMarca: searchData.idBlCrMarca,
      idBlCrColor: searchData.idBlCrColor,
      idBlCrDiametro: searchData.idBlCrDiametro,
      estado: searchData.estado,
      rows: rowsPerPage,
      first: currentPage * rowsPerPage,
    };

    setIsDoingSomething(true);
    const response = await getBlockProductos(_params);
    setIsDoingSomething(false);

    if (response.ok) {
      setTotalRowsCount(response.data.count);
      setItemsCrud(response.data.data);
    } else {
      setMessage({
        messageText: response.messageText,
        severity: response.messageSeverity,
      });
      setShowMessage(true);
    }
  };
  //
  // ################################################################################
  //
  const handleClickActionCrud = (itemCrud, action) => {
    let _itemCrud = {};

    if (action !== "new") {
      const loadItem = async () => {

        setIsDoingSomething(true);
        const response = await getBlockProducto({ id: itemCrud.id });
        setIsDoingSomething(false);

        if (response.ok) {
          let _response = response.data.data;
          _itemCrud = {
            id: _response.id,
            descripcion: _response.descripcion,
            descripcionCorta: _response.descripcion_corta,
            observaciones: _response.observaciones,
            blCrTipo: {
              id: _response.id_bl_cr_tipo,
              label: _response.descripcion_bl_cr_tipo
            },
            blCrMaterial: {
              id: _response.id_bl_cr_material,
              label: _response.descripcion_bl_cr_material
            },
            blCrMarca: {
              id: _response.id_bl_cr_marca,
              label: _response.descripcion_bl_cr_marca
            },
            blCrColor: {
              id: _response.id_bl_cr_color,
              label: _response.descripcion_bl_cr_color
            },
            blCrDiametro: {
              id: _response.id_bl_cr_diametro,
              label: _response.valor_bl_cr_diametro
            },
            conAdicion: _response.con_adicion,
          };
          setActionCrud(action);
          setItemCrud(_itemCrud);
          setOpenDialog(true);
        } else {
          setMessage({
            severity: response.messageSeverity,
            messageText: response.messageText,
          });
          setShowMessage(true);
          return;
        }
      };
      loadItem();
    } else {
      setActionCrud(action);
      setItemCrud(_itemCrud);
      setOpenDialog(true);
    }
  };
  //
  // ################################################################################
  //
  const handleDialogSave = () => {
    load();
    setOpenDialog(false);
  };
  //
  // ################################################################################
  //
  const handleDialogClose = () => {
    setOpenDialog(false);
  };
  //
  // ################################################################################
  // 
  const handleKeyDown = (event) => {
    if (event.key === 'Enter') {
      handleBuscar();
    }
  };
  //
  // ################################################################################
  //
  const loadBlCrTipos = async () => {
    const response = await getCacheData("bl_cr_tipo")
    if (response.ok) {
      let _response = response.data.data;
      let _var = [];
      _response.forEach((item) => {
        _var.push({
          id: item.id,
          label: item.descripcion,
        });
      });
      setBlCrTipos(_var);
    } else {
      setBlCrTipos([]);
      setMessage({
        messageText: response.messageText,
        severity: response.messageSeverity,
      });
      setShowMessage(true);
    }
  };
  //
  // ################################################################################
  //
  const loadBlCrMateriales = async () => {
    const response = await getCacheData("bl_cr_material")
    if (response.ok) {
      let _response = response.data.data;
      let _var = [];
      _response.forEach((item) => {
        _var.push({
          id: item.id,
          label: item.descripcion,
        });
      });
      setBlCrMateriales(_var);
    } else {
      setBlCrMateriales([]);
      setMessage({
        messageText: response.messageText,
        severity: response.messageSeverity,
      });
      setShowMessage(true);
    }
  };
  //
  // ################################################################################
  //
  const loadBlCrMarcas = async () => {
    const response = await getCacheData("bl_cr_marca")
    if (response.ok) {
      let _response = response.data.data;
      let _var = [];
      _response.forEach((item) => {
        _var.push({
          id: item.id,
          label: item.descripcion,
        });
      });
      setBlCrMarcas(_var);
    } else {
      setBlCrMarcas([]);
      setMessage({
        messageText: response.messageText,
        severity: response.messageSeverity,
      });
      setShowMessage(true);
    }
  };
  //
  // ################################################################################
  //
  const loadBlCrColores = async () => {
    const response = await getCacheData("bl_cr_color")
    if (response.ok) {
      let _response = response.data.data;
      let _var = [];
      _response.forEach((item) => {
        _var.push({
          id: item.id,
          label: item.descripcion,
        });
      });
      setBlCrColores(_var);
    } else {
      setBlCrColores([]);
      setMessage({
        messageText: response.messageText,
        severity: response.messageSeverity,
      });
      setShowMessage(true);
    }
  };
  //
  // ################################################################################
  //
  const loadBlCrDiametros = async () => {
    const response = await getCacheData("bl_cr_diametro")
    if (response.ok) {
      let _response = response.data.data;
      let _var = [];
      _response.forEach((item) => {
        _var.push({
          id: item.id,
          label: item.valor,
        });
      });
      setBlCrDiametros(_var);
    } else {
      setIsDoingSomething(false);
      setBlCrDiametros([]);
      setMessage({
        messageText: response.messageText,
        severity: response.messageSeverity,
      });
      setShowMessage(true);
    }
  };
  //
  // ################################################################################
  //
  return (
    <>
      <Paper elevation={0} sx={{ mx: 0.5, maxWidth: "100%" }}>
        <Paper elevation={1} >
          <Box sx={{ mx: 1, px: 1, pb: 1 }}>
            <Grid container spacing={1}>
              <Grid item xs={12}>
                <Box sx={{ mt: 1 }} display="flex" justifyContent="space-between" alignItems="center">
                  <Typography variant="h5" display="block" gutterBottom >
                    {nameItemsText}
                  </Typography>
                </Box>
              </Grid>

              <Grid item xs={12} md={12} lg={2}>
                <TextField
                  sx={{ width: "100%" }}
                  inputProps={{
                    autoComplete: "off",
                  }}
                  id="descripcion"
                  label="Descripcion"
                  variant="outlined"
                  size="small"
                  name="descripcion"
                  value={searchData.descripcion}
                  onChange={handleChange}
                  onKeyDown={handleKeyDown}
                />
              </Grid>

              <Grid item xs={12} md={12} lg={2}>
                <TextField
                  sx={{ width: "100%" }}
                  inputProps={{
                    autoComplete: "off",
                  }}
                  id="descripcionCorta"
                  label="Descripcion Abreviada"
                  variant="outlined"
                  size="small"
                  name="descripcionCorta"
                  value={searchData.descripcionCorta}
                  onChange={handleChange}
                  onKeyDown={handleKeyDown}
                />
              </Grid>

              <Grid item xs={12} md={12} lg={2}>
                <Autocomplete
                  id="id-tipo"
                  size="small"
                  value={
                    valueACBlCrTipo && valueACBlCrTipo.id
                      ? valueACBlCrTipo
                      : null
                  }
                  onChange={(event, newValue) => {
                    setValueACBlCrTipo(newValue);
                    setSearchData({
                      ...searchData,
                      idBlCrTipo: newValue ? newValue.id : "",
                    });
                  }}
                  inputValue={inputValueACBlCrTipo}
                  onInputChange={(event, newInputValue) => {
                    setInputValueACBlCrTipo(newInputValue);
                  }}
                  options={blCrTipos}
                  getOptionLabel={(option) => option.label || ""}
                  renderInput={(params) => <TextField {...params} label="Tipo" />}
                  isOptionEqualToValue={(option, value) => {
                    if (!value || !value.id) return false;
                    return option.id === value.id;
                  }}
                  disableClearable={true}
                />
              </Grid>

              <Grid item xs={12} md={12} lg={2}>
                <Autocomplete
                  id="id-material"
                  size="small"
                  value={
                    valueACBlCrMaterial && valueACBlCrMaterial.id
                      ? valueACBlCrMaterial
                      : null
                  }
                  onChange={(event, newValue) => {
                    setValueACBlCrMaterial(newValue);
                    setSearchData({
                      ...searchData,
                      idBlCrMaterial: newValue ? newValue.id : "",
                    });
                  }}
                  inputValue={inputValueACBlCrMaterial}
                  onInputChange={(event, newInputValue) => {
                    setInputValueACBlCrMaterial(newInputValue);
                  }}
                  options={blCrMateriales}
                  getOptionLabel={(option) => option.label || ""}
                  renderInput={(params) => <TextField {...params} label="Material" />}
                  isOptionEqualToValue={(option, value) => {
                    if (!value || !value.id) return false;
                    return option.id === value.id;
                  }}
                  disableClearable={true}
                />
              </Grid>

              <Grid item xs={12} md={12} lg={2}>
                <Autocomplete
                  id="id-marca-producto"
                  size="small"
                  value={
                    valueACBlCrMarca && valueACBlCrMarca.id
                      ? valueACBlCrMarca
                      : null
                  }
                  onChange={(event, newValue) => {
                    setValueACBlCrMarca(newValue);
                    setSearchData({
                      ...searchData,
                      idBlCrMarca: newValue ? newValue.id : "",
                    });
                  }}
                  inputValue={inputValueACBlCrMarca}
                  onInputChange={(event, newInputValue) => {
                    setInputValueACBlCrMarca(newInputValue);
                  }}
                  options={blCrMarcas}
                  getOptionLabel={(option) => option.label || ""}
                  renderInput={(params) => <TextField {...params} label="Marca del Producto" />}
                  isOptionEqualToValue={(option, value) => {
                    if (!value || !value.id) return false;
                    return option.id === value.id;
                  }}
                  disableClearable={true}
                />
              </Grid>

              <Grid item xs={12} md={12} lg={2}>
                <Autocomplete
                  id="id-color"
                  size="small"
                  value={
                    valueACBlCrColor && valueACBlCrColor.id
                      ? valueACBlCrColor
                      : null
                  }
                  onChange={(event, newValue) => {
                    setValueACBlCrColor(newValue);
                    setSearchData({
                      ...searchData,
                      idBlCrColor: newValue ? newValue.id : "",
                    });
                  }}
                  inputValue={inputValueACBlCrColor}
                  onInputChange={(event, newInputValue) => {
                    setInputValueACBlCrColor(newInputValue);
                  }}
                  options={blCrColores}
                  getOptionLabel={(option) => option.label || ""}
                  renderInput={(params) => <TextField {...params} label="Color" />}
                  isOptionEqualToValue={(option, value) => {
                    if (!value || !value.id) return false;
                    return option.id === value.id;
                  }}
                  disableClearable={true}
                />
              </Grid>

              <Grid item xs={12} md={12} lg={2}>
                <Autocomplete
                  id="id-diametro"
                  size="small"
                  value={
                    valueACBlCrDiametro && valueACBlCrDiametro.id
                      ? valueACBlCrDiametro
                      : null
                  }
                  onChange={(event, newValue) => {
                    setValueACBlCrDiametro(newValue);
                    setSearchData({
                      ...searchData,
                      idBlCrDiametro: newValue ? newValue.id : "",
                    });
                  }}
                  inputValue={inputValueACBlCrDiametro}
                  onInputChange={(event, newInputValue) => {
                    setInputValueACBlCrDiametro(newInputValue);
                  }}
                  options={blCrDiametros}
                  getOptionLabel={(option) => option.label || ""}
                  renderInput={(params) => <TextField {...params} label="Diámetro" />}
                  isOptionEqualToValue={(option, value) => {
                    if (!value || !value.id) return false;
                    return option.id === value.id;
                  }}
                  disableClearable={true}
                />
              </Grid>

              <Grid item xs={12} md={12} lg={2}>
                <FormControl sx={{ width: "100%" }}>
                  <InputLabel id="tipo-estado">
                    Estado
                  </InputLabel>
                  <Select
                    sx={{ width: "100%", mr: 1 }}
                    labelId="estado"
                    label="Estado"
                    id="estado"
                    name="estado"
                    value={searchData.estado}
                    size="small"
                    onChange={handleChange}
                  >
                    {estadoOptions.map((item) => (
                      <MenuItem key={item.id} value={item.id}>
                        {item.descripcion}
                      </MenuItem>
                    ))}
                  </Select>
                </FormControl>
              </Grid>
            </Grid>
          </Box>

          <Box sx={{ mx: 1, mb: 1, px: 1, pb: 1 }}>
            <Grid container spacing={1}>

              {_crearBlockProducto && (
                <Grid item xs={12} md={12} lg={1}>
                  <Box sx={{ display: "flex", gap: 1 }}>
                    <Tooltip title="crear nuevo producto de block">
                      <Button
                        fullWidth
                        className="btn-add"
                        variant="contained"
                        size="small"
                        onClick={() => handleClickActionCrud({}, "new")}
                        startIcon={<Add />}
                      >
                        Nuevo
                      </Button>
                    </Tooltip>
                  </Box>
                </Grid>
              )}

              <Grid item xs={12} md={12} lg={1}>
                <Box sx={{ display: "flex", gap: 1 }}>
                  <Tooltip title="buscar">
                    <Button
                      fullWidth
                      variant="contained"
                      size="small"
                      onClick={handleBuscar}
                      startIcon={<SearchIcon />}
                    >
                      Buscar
                    </Button>
                  </Tooltip>
                </Box>
              </Grid>

              <Grid item xs={12} md={12} lg={1}>
                <Box sx={{ display: "flex", gap: 1 }}>
                  <Tooltip title="limpiar filtros">
                    <Button
                      fullWidth
                      variant="outlined"
                      size="small"
                      onClick={handleLimpiar}
                      startIcon={<CleaningServicesIcon />}
                    >
                      Limpiar
                    </Button>
                  </Tooltip>
                </Box>
              </Grid>
            </Grid>
          </Box>
        </Paper>

        <DataGrid
          rows={itemsCrud}
          columns={tableColumns}
          {...tableOptions}
        />
      </Paper>

      {openDialog && (
        <BlockProductoDialog
          onSave={handleDialogSave}
          onClose={handleDialogClose}
          itemCrud={itemCrud}
          actionCrud={actionCrud}
          setMessage={setMessage}
          setShowMessage={setShowMessage}
        />
      )}

      {showMessage && (
        <Message
          showMessage={showMessage}
          setShowMessage={setShowMessage}
          message={message}
        />
      )}

      <WaitingDialog open={isDoingSomething} />
    </>
  );
};
export default BlockProductoTable;
